import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {  theme } from "src/config";
import { usePopper } from "react-popper";
import { Placement }  from '@popperjs/core';

export interface ITooltipProps {
  children?: React.ReactNode;
  content?: React.ReactNode;
  delay?: number;
  className?: string;
  element?: HTMLElement | string;
  invisible?: boolean;
  placement?: Placement;
}

const Container = styled.div`
  position: relative;
`;

const TooltipArrow = styled.div<{invisible: boolean}>`
  width:  0.8rem;
  height: 1rem;
  &::before {
    content:    "";
    background: ${(p) => p.invisible ? 'transparent' : theme.color.black};
    width:      1rem;
    height:     1rem;
    transform:  translate(-50%, -50%) rotate(45deg);
    position:   absolute;
    top:        5px;
    left:       0;
  }
`;

const StyledTooltip = styled.div<ITooltipProps>`
  position:      absolute;
  border-radius: 4px;
  width:         max-content;
  overflow-wrap: break-word;
  max-width:     20rem;
  background:    ${(p) => p.invisible ? 'none' : theme.color.black};
  color:         ${(p) => p.invisible ? 'transparent' : theme.color.white};
  transform:     translateX(-50%);
  padding:       0.8rem;
  font-size:     ${theme.font.size.xsmall};
  font-weight:   ${theme.font.weight.normal};
  /* z-index:       9999; */
  text-align:    left;

  &[data-popper-placement^="right"] {
    ${TooltipArrow} {
      left: 0px;
    }
  }

  &[data-popper-placement^="left"] {
    ${TooltipArrow} {
      right: -8px;
    }
  }

  &[data-popper-placement^="top"] {
    ${TooltipArrow} {
      bottom: -5px;
    }
  }

  &[data-popper-placement^="bottom"] {
    ${TooltipArrow} {
      top: -5px;
    }
  }
`;

export const Tooltip = ({ children, content, delay, className, invisible, placement = "auto" }: ITooltipProps): JSX.Element => {
  const [active, setActive] = useState(false);
  // const intervalIdRef = React.useRef<NodeJS.Timeout | null>(null);

  const showTip = () => {
    setActive(true);
    // clearInterval(intervalIdRef.current);
    // intervalIdRef.current = setTimeout(() => {
    //   setActive(true);
    // }, delay || 250);
  };

  const hideTip = () => {
    // clearInterval(intervalIdRef.current);
    setActive(false);
  };

  useEffect(() => {
    // Clear interval on unmount
    // return () => {
    //   clearInterval(intervalIdRef.current);
    // }
  }, []);

  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      { name: 'arrow', options: { element: arrowElement } },
      { name: 'offset', options: { offset: [0, 16]}},
      // { name: 'preventOverflow'}
    ],
  });

  return (
    <Container ref={setReferenceElement} onMouseEnter={showTip} onMouseLeave={hideTip} className={className} style={active ? {zIndex: 999} : {}}>
      {(active && content) && (
        <StyledTooltip invisible={invisible} ref={setPopperElement} style={{...styles.popper, ...{zIndex: active ? 999 : 'initial' } }} {...attributes.popper}>
          <TooltipArrow invisible={invisible} ref={setArrowElement} style={styles.arrow}/>
          {React.Children.map(content, (child) => child)}
        </StyledTooltip>
      )}
      {React.Children.map(children, (child) => child)}
    </Container>
  );
};
